import { LOCALE } from "./localeConstants.js";

const setLocale = locale => {
  return {
    type: LOCALE.SET,
    locale
  };
};

const requestLocaleCopy = locale => {
  return {
    type: LOCALE.REQUEST,
    locale
  };
};

const receiveLocaleCopy = (locale, json) => {
  return {
    type: LOCALE.RECEIVE,
    data: json,
    locale
  };
};

const failureLocaleCopy = response => {
  return {
    type: LOCALE.FAILURE,
    response
  };
};

// using the following export pattern so we can mock more easily using jest

const localeActions = {
  setLocale,
  requestLocaleCopy,
  receiveLocaleCopy,
  failureLocaleCopy
};

export default localeActions;
